<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label for="itemname">{{ bureauTitle }}</label>
                    <select
                        v-model="selectedCreditBureauId"
                        @change="getCreditBureauList(selectedCreditBureauId)"
                        id="creditbureau"
                        name="creditbureau"
                        class="form-control"
                        :class="{'is-invalid' : creditBureauError}"
                        required
                    >
                        <option v-for="creditBureau in creditBureaus" v-bind:value="creditBureau.id">{{ creditBureau.name }}</option>
                    </select>
                    <span v-if="creditBureauError" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
            <div class="col-lg-8 col-md-8 col-12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <vue-good-table
      v-show="isInputFormActive"
      ref="inquiry-table"
      v-on:selected-rows-change="creditorSelectionChanged"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :select-options="{
        enabled: true,
        disableSelectInfo: true,
        selectOnCheckboxOnly: true
      }"
    >
        <template #table-row="props">
            <span v-if="props.column.field === 'action'">
                <div class="d-flex align-items-center col-actions">
                    <a class="mr-1 text-primary" data-toggle="tooltip" data-placement="top" title="Individual Dispute">
                        <vue-feather type="send" @click="dispute(props.row.id)"></vue-feather>
                    </a>
                </div>
            </span>
        </template>
    </vue-good-table>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data">
                            <input type="hidden" name="_token" :value="csrf">
                            <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="selectedCreditBureauId" hidden>
                            <div class="col-md-12">
                                <div id="editor">
                                </div>
                                <div class="d-flex justify-content-center my-1">
                                    <button class="btn btn-sm-block btn-primary" type="submit" name="editorType"
                                        value="1">
                                        {{ localizationStore.translate("letter.left.submit.button.text") }}
                                    </button>
                                    <button
                                        class="btn btn-outline-primary ml-1"
                                        @click="$refs.spinner.spinLetter()"
                                        type="button"
                                    >
                                        {{ localizationStore.translate("spin.letter.button.text") }}
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRef' />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRef" hidden>
            <p>
                {{ userInfo.firstname }} {{ userInfo.lastname }}
                <br />
                {{ userInfo.address }}
                <br />
                {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                <br />
                {{ userInfo.ssn }}
                <br />
                <br />
                {{ selectedCreditBureau.address_name }}
                <br />
                {{ selectedCreditBureau.street_address }}
                <br />
                {{ selectedCreditBureau.city }}, {{ selectedCreditBureau.state_abbrev }} {{ selectedCreditBureau.zipcode }}
                <br />
                <br />
                Date: {{ date }} 
            </p>
            <p v-if="selectedCreditor.length > 0" style="padding: 10px 50px">
                Dear <strong>{{ selectedCreditBureau.name }}</strong>:
                <br />
                Re: <strong>{{ selectedCreditor[0].furnisher_name }}</strong>: and <strong>{{ selectedCreditor[0].reference_number }}</strong>:
                <br />
            </p>
            <p class="letter-content" style="padding: 10px 50px">
                I am contacting you because you claimed to have completed a reasonable investigation with the furnisher of information and verified the account listed above as reporting 100% accurate. However, this account is STILL inaccurate and your company is STILL continuing to report errors on my credit file, which is causing damage to my credit score.
            </p>
            <p v-if="selectedCreditor.length > 0" style="padding: 0px 50px">
                <strong>
                NAME OF ACCOUNT: 
                </strong>
                {{ selectedCreditor[0].furnisher_name }}
                <br />
                <strong>REFERENCE NUMBER: </strong>{{ selectedCreditor[0].reference_number }}
                <br /> The docket number/Case number/Date filed/Liability Amount/Claim Amount/Status you are reporting for this account is incorrect, and doesn’t match my records.
            </p>
            <p class="letter-content" style="padding: 10px 50px">
                I have previously requested that you investigate this information and you have failed to correct the errors you are reporting on my credit report. Now is not the time to update, I demand that you <strong>IMMEDIATELY DELETE</strong> this inaccurate information from my credit report.
                <br />
                <br />
                After doing so please provide me with an updated credit report reflecting the changes.
            </p>
            <p>
                Best Regards,
                <br />
                <br />
                {{ userInfo.firstname }} {{ userInfo.lastname }}
                <br />
            </p>
        </div>
    </section>
</template>
<script>
  import { reactive, computed } from 'vue'
  import { ref } from 'vue'
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  export default {
    props: {
        propBureauTitle: {
            type: String
        },
        propSelectDefaultOption: {
            type: String
        },
        csrf: {
            type: String
        },
        propCreditBureaus: {
            type: [Array, Object]
        },
        propUserInfo: {
            type: [Array, Object]
        },
    },
    components: {
        VueGoodTable,
    },
    setup(props) {
        const selectedCreditBureauId = ref(props.propCreditBureaus[0].id);
        const editorRef = ref(null);
        const isInputFormActive = ref(true),
            creditBureauError = ref(false),
            date = ref(null);
        return {
            bureauTitle: props.propBureauTitle,
            creditBureaus: props.propCreditBureaus,
            selectDefaultOption: props.propSelectDefaultOption,
            userInfo: props.propUserInfo,
            selectedCreditBureauId,
            editorRef,
            isInputFormActive,
            creditBureauError,
            date,
            localizationStore: useLocalizationStore(),
        };
    },
    data(){
        const selectedCreditor = reactive([]);
        return {
          columns: [
            {
              label: 'TYPE',
              field: 'type',
            },
            {
              label: 'REFERENCE NUMBER',
              field: 'reference_number',
            },
            {
              label: 'ACCOUNT STATUS',
              field: 'status',
            },
            {
              label: 'Action',
              field: 'action',
            }
          ],
          rows: [],
          searchTerm: '',
          selectedCreditor
        };
    },
    created() {
        // console.log(this.creditBureaus);
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data));
        this.getCreditBureauList(this.selectedCreditBureauId);
    },
    computed: {
        // a computed getter
        selectedCreditBureau() {
            return this.creditBureaus.find((attribute) => {
                if (attribute.id == this.selectedCreditBureauId) {
                    return attribute;
                }
            })
        },
        isCreditBureauSelected() {
            return (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") ? false : true;
        }
    },
    methods: {
      dispute: function (id) {
        this.selectedCreditor[0] = this.rows.find((attribute) => {
            if (attribute.id == id) {
                return attribute;
            }
        });
        setTimeout(() => {
            tinymce.activeEditor.setContent(this.editorRef.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }, "100");
      },
      goBack: function () {
        this.isInputFormActive = !this.isInputFormActive;
      },
      validate: function () {
        if (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") {
            this.creditBureauError = true;
        }
        else {
            this.creditBureauError = false;
        }
        return !this.creditBureauError;
      },
      getCreditBureauList: function (type) {
        axios.get(this.routes.listCreditBureau.replace(':type', type)).then(response => {
                this.rows = response.data.data
            }
        );
      },
      creditorSelectionChanged: function (params) {
        this.selectedCreditor = params.selectedRows;
      }
    }
  };
</script>